<div>
  <div *ngIf="url_available && Fileurl!='' && is_word_doc ">
    <ngx-doc-viewer url="{{Fileurl}}" viewer="google" disableContent="popout-hide" style="width:100%;height:93vh;">
    </ngx-doc-viewer>


  </div>
  <div *ngIf="url_available && Fileurl!='' && is_image_or_video ">
    <ngx-doc-viewer url="{{Fileurl}}" viewer="url" style="width:100%;height:90vh; margin: 5%;">
    </ngx-doc-viewer>
  </div>
  <div *ngIf="url_available && Fileurl!='' && is_pdf ">
    <ngx-doc-viewer url="{{Fileurl}}" viewer="google" disableContent="popout-hide" style="width:100%;height:93vh;">
    </ngx-doc-viewer>


  </div>

  <div *ngIf="invalid" style="text-align: center; padding-top: 10px;">No Resource Found </div>
</div>